import { VideoSource } from "@/constants/media";
import { useGetVideoURL } from "../hooks";
import VideoIFrame from "../VideoIFrame";

// https://help.vimeo.com/hc/en-us/articles/12426260232977-About-Player-parameters
export type VimeoOptions = Partial<{
  autoplay: boolean;
}>;

export interface VimeoVideoProps {
  videoId: string;
  options?: VimeoOptions;
}

const defaultOptions: VimeoOptions = {
  autoplay: true,
};

export default function VimeoVideo(props: VimeoVideoProps) {
  const { videoId, options: customOptions } = props;
  const videoURL = useGetVideoURL(VideoSource.Vimeo, videoId);

  return (
    <VideoIFrame
      src={videoURL}
      options={{ ...defaultOptions, ...customOptions }}
    />
  );
}
